import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import { ItemErrorComponent } from '../../../components/item-form-error/item-form-error.component';
import { ItemFormErrorWithTranslatorComponent } from '../../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { SiffiLanguagePickerComponent } from '../../../components/siffi-language-picker/siffi-language-picker.component';
import { Subscription } from 'rxjs';
import Config from '../../../utils/config.service';
import UserRestServices from '../../../services/user-rest.service';
import Session from '../../../utils/session.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import ScreeningEscalationRestService from "../../../services/screening-escalation-rest.service";
import AppLanguageService from "../../../services/app-language.service";

@Component({
	standalone: true,
	selector: 'login',
	templateUrl: './login.component.html',
	imports: [
		CommonModule, TranslateUnauthenticatedPipe, ItemErrorComponent, RouterLink,
		ItemFormErrorWithTranslatorComponent, FormsModule, LoaderOverlayComponent,
		SiffiLanguagePickerComponent
	]
})
export default class LoginView implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private screeningRest: ScreeningEscalationRestService = inject(ScreeningEscalationRestService);

	private appLanguageService: AppLanguageService = inject(AppLanguageService);

	vm: any = undefined;
	private titleSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		this.determineLocation(queryParams);

		this.vm.targetUrl = queryParams['targetUrl'];
		this.vm.screeningToken = queryParams['screeningToken'] || this.screeningRest.getPilotToken();
		this.vm.screeningOrg = queryParams['screeningOrg'] || this.screeningRest.getPilotOrg();
		this.vm.isScreeningLogin = !!this.vm.screeningToken;

		this.vm.isLanguageMenuOpen = false;
		this.vm.locale = queryParams['locale'] || 'en_GB';
		this.vm.localeParams = this.vm.locale ? { locale: this.vm.locale } : undefined;
		if (this.vm.isScreeningLogin) {
			this.screeningRest.savePilotContext(this.vm.screeningToken, this.vm.screeningOrg, this.vm.locale);
		}
		window.sessionStorage.setItem("locale", this.vm.locale);
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(this.vm.origin);
		this.vm.languages = this.config.getSettings().Languages;
		var currentSession = this.session.getSession();
		this.vm.isAuthenticated = !!currentSession?.user;
		if (this.vm.isAuthenticated) {
			if (this.vm.targetUrl) window.location.replace(this.vm.targetUrl);
			else this.angularRoutingHelperService.home(currentSession.user);
			return;
		}
		
		this.vm.language = window.navigator.language;
		this.vm.lang = window.sessionStorage.getItem("locale") || 'et_EE' ;
		
		this.vm.setLocale = this.setLocale;
		this.vm.toggleLangMenu = this.toggleLangMenu;
		this.vm.getLocaleOption = this.getLocaleOption;
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.login = this.login;
		
		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('Login.Login_Title');
	}

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}
	
	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getPublicWebHomeUrl(this.vm.origin, this.vm.locale);
	}
	
	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}
	
	login(mainForm: any) {
		this.vm.originError = undefined;
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		this.vm.loading = true;
		var credentials: any = {
			username: this.vm.email,
			password: this.vm.password,
			verificationCode: this.vm.verificationCode,
			totpVerificationCode: this.vm.verificationCode,
			use2faFeature: true,
			origin: this.vm.origin
		}
		if (this.vm.screeningToken) {
			credentials.token = this.vm.screeningToken;
		}
		this.userRestServices.login(credentials).then(
			(response) => {
				console.log(response.status);
				if (response.status === 200) {
					this.vm.isVerificationProcess = false;
					if (this.vm.screeningToken) {
						this.screeningRest.clearPilotContext();
					}
					if (this.vm.targetUrl) {
                        window.location.replace(this.vm.targetUrl);
					} else if (this.vm.screeningToken) {
						window.location.href = this.config.getPlatformAppUrl();
						// Reinitialize the authenticated layout after leaving screening.
						window.location.reload();
					} else if (response.body && response.body.user) {
						this.session.handleLogin(response.body, (sessionData) => {
							this.angularRoutingHelperService.home(sessionData.user, true).then((navigated) => {
								if (navigated) {
									window.location.reload();
								}
							});
						});
					} else {
						window.location.href = "/app/";
					}
				}
			},
			(err) => {
				this.vm.loading = false;
				console.log(err.error);
				if (err.status === 403 && err.error === "2FA_VERIFICATION_CODE_REQUIRED") {
					this.vm.submitted = false;
					this.vm.verificationCode = "";
					this.vm.isVerificationProcess = true;
					this.vm.showVerificationInput = true;
				} else if (err.status === 403 && err.error === "2FA_WRONG_VERIFICATION_CODE") {
					this.vm.verificationCode = "";
					this.vm.showWrongVerificationError = true;
				} else if (err.status === 403 && err.error === "2FA_TIMESTAMP_EXPIRED") {
					this.vm.verificationCode = "";
					this.vm.showExpiredTimestampError = true;
				} else if (err.status === 403 && err.error === "TOTP_VERIFICATION_CODE_REQUIRED") {
					this.vm.submitted = false;
					this.vm.isTotpVerification = true;
					this.vm.verificationCode = "";
					this.vm.isVerificationProcess = true;
					this.vm.showVerificationInput = true;
				} else if(err.status === 403 && err.error === "TOTP_WRONG_VERIFICATION_CODE") {
					this.vm.verificationCode = "";
					this.vm.showWrongVerificationError = true;
				} else {
					if (err.error && err.error.indexOf && err.error.indexOf('Account origin mismatch') > -1) {
						this.vm.originError = err.error
					}
					this.vm.showError = true;
				}
			}
		);
	}

	toggleLangMenu() {
		this.vm.isLanguageMenuOpen = !this.vm.isLanguageMenuOpen;
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}

	private getRouteParams() {
		var params: any = this.vm.locale ? { locale: this.vm.locale } : {};
		if (this.vm.origin && this.vm.origin !== 'siffi.com') {
			params.origin = this.vm.origin;
		}
		return params;
	}

	private determineLocation(queryParams) {
		var host: any = window.location.hostname;
		var url: any = window.location.href;
		var requestedOrigin: any = queryParams['origin'];
		if (host.includes('minudoc')) {
			this.vm.origin = host.includes('minudoc.fi') ? 'minudoc.fi' : 'minudoc.ee';
			this.vm.product = url.includes('eelvisiit') ? 'PREVISIT' : 'MINUDOC';
			this.vm.headerClass = '';
			this.vm.brandName = this.vm.product === 'PREVISIT' ? 'eelvisiit' : 'MinuDoc';
			return;
		}
		if (requestedOrigin && requestedOrigin.includes('minudoc')) {
			this.vm.origin = requestedOrigin;
			this.vm.product = 'MINUDOC';
			this.vm.headerClass = '';
			this.vm.brandName = 'MinuDoc';
			return;
		}
		this.vm.origin = host.includes('siffi') ? 'siffi.com' : (requestedOrigin || 'siffi.com');
		this.vm.product = 'SIFFI';
		this.vm.headerClass = 'o-container c-container';
		this.vm.brandName = 'Siffi';
	}

	private resolveLogoSuffix(locale: string) {
		var normalizedLocale: any = this.appLanguageService.normalizeLocale(locale);
		var languageCode: any = (normalizedLocale || 'en_GB').split('_')[0];
		if (['en', 'et', 'ru', 'fi'].indexOf(languageCode) === -1) {
			return 'en';
		}
		return languageCode;
	}
}
